import EntityVerified from './EntityVerified'

export default EntityVerified
